import { Slide } from "@jelly/lesson";

import { task as task02 } from "../../../../../task/course-02/lesson-22/task-02";

const task: Slide = {
  title: "Which physical measure can be determined by testing a subject’s hearing threshold?",
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task02.id,
        },
      },
    },
  },
};

export default task;
